import { FDCConcurrenceLevelSideEffect } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { useFDCTrackerContext } from '../../../../FDCTrackerContext'
import { ConcurrenceLevelFormItemProps } from './types'
import { useDisabledOptions } from 'hooks/useDisabledOptions'

const ConcurrenceLevelFormItem: React.FC<ConcurrenceLevelFormItemProps> = ({
  filtered = false,
  required = false,
  disabled,
}) => {
  const { metadata } = useFDCTrackerContext()
  const options = useOptions({
    items: metadata?.fdcConcurrenceLevels?.filter(({ sideEffectId }) =>
      filtered
        ? sideEffectId !== FDCConcurrenceLevelSideEffect.EarlyClosure.id
        : true
    ),
    value: 'id',
    label: 'name',
    tooltip: 'description',
    sort: 'name',
  })
  const [disabledOptions, { some }] = useDisabledOptions(disabled)
  return (
    <CIMSFormItem
      name="concurrenceLevel"
      label="Suggested Level"
      help={HelpMessage.FieldDesignChanges.FDCTracker.ConcurrenceLevel}
      requiredMessage={
        required ? 'Please enter a concurrence level' : undefined
      }
      disabled={disabledOptions}
    >
      <CIMSSelect
        options={options}
        loading={metadata?.loading}
        disabled={some}
      />
    </CIMSFormItem>
  )
}

export default ConcurrenceLevelFormItem
